import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";
import * as React from "react";
import { TABLE_LINE_HEIGHT } from "../../config";
import { THEME } from "../../theme/ThemeStore";
import { t } from "../../i18n/util";
import { TableHeaderOption, TableStore } from "../../stores/TableStore";
import { applicantListHeaderEnum } from "../../types/models";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { TableSelection } from "../hooks/useTableSelection";
import { CustomCheckbox } from "./CustomCheckbox";

type Props = {
    fields: TableHeaderOption<applicantListHeaderEnum>[];
    flexGrowArray: number[];
    select?: TableSelection;
    tableStore: TableStore;
    hideCheckbox?: boolean;
};

export const TableHeader = ({ fields, flexGrowArray, select, tableStore, hideCheckbox }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <TableHead>
            <TableRow
                style={{
                    height: TABLE_LINE_HEIGHT,
                    display: "flex",
                    flexGrow: 1
                }}
            >
                {!hideCheckbox && select && (
                    <TableCell
                        style={{ display: "flex", alignItems: "center", padding: isMobile ? 12 : "0 36px 0 12px" }}
                    >
                        <CustomCheckbox
                            onChange={select.toggleSelectAll}
                            checked={select.allSelected}
                            indeterminate={select.someSelected}
                            style={select.someSelected ? { color: THEME.customColors.primary } : undefined}
                        />
                    </TableCell>
                )}
                {fields.map((option, index) => (
                    <TableCell
                        key={option.value}
                        className="body2semibold"
                        style={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            fontSize: 12,
                            color: THEME.customColors.body1Dark,
                            flex: flexGrowArray[index]
                        }}
                    >
                        <TableSortLabel
                            active={tableStore.orderBy === option.value}
                            direction={tableStore.orderDir}
                            disabled={option.sort === false}
                            onClick={() => tableStore.onChangeSort(option.value)}
                        >
                            {t(option.messageId)}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};
